


















import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  @Prop({ type: Boolean, default: true }) public titleOneShow;
  @Prop({ type: Boolean, default: false }) public titleTwoShow;
  @Prop({ type: Boolean, default: false }) public titleThreeShow;
  @Prop({ type: Boolean, default: false }) public menuState;
  public addNavs(ev) {
    this.$emit("addNav", ev);
  }
}
